export const _SitemapFornecedores = {
    url: 'fornecedores',
    descricao: 'Fornecedores',
    nome: 'Fornecedores',
    permissao: ['VisualizarFornecedores'],
    fullUrl: '/fornecedores/menu',
    children:
        {
            ['menu']: {
                url: 'menu',
                descricao: 'Menu de fornecedores',
                nome: 'Menu de fornecedores',
                permissao: ['VisualizarFornecedores'],
                fullUrl: '/fornecedores/menu',
            },
            ['detalhes']: {
                url: 'detalhes',
                descricao: 'Detalhes do fornecedor',
                nome: 'Detalhes do fornecedor',
                permissao: ['VisualizarFornecedores'],
                fullUrl: '/fornecedores/detalhes',
            },
            ['lista']: {
                url: 'lista',
                descricao: 'Lista de fornecedores',
                nome: 'Lista de fornecedores',
                permissao: ['VisualizarFornecedores'],
                fullUrl: '/fornecedores/lista',
            },
        },
} as const